import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { DynamicModule } from 'ng-dynamic-component';
import { VhStringPercentPipeModule } from 'vhobjects-service';
import { MaterialModule } from 'vhobjects-service';
import { NgZorroAntModule } from 'vhobjects-service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TextFormatConfigModule } from 'vhobjects-service';
import { HideShowConfigModule } from 'vhobjects-service';
import { LetterSpacingConfigModule } from 'vhobjects-service';
import { VhLanguagePipeModule } from './vh-language.pipe';
import { LineHeightConfigModule } from 'vhobjects-service';
import { ColorPickerModule } from 'ngx-color-picker';
import { TextStyleConfigModule } from 'vhobjects-service';
import { LinkPageModule } from 'vhobjects-service';
import { ShadowConfigModule } from 'vhobjects-service';
import { SymbolConfigModule } from 'vhobjects-service';
import { ObjectFitConfigModule } from 'vhobjects-service';
import { DataAdminManagementConfigModule } from 'vhobjects-service';
import { PositionOutConfigModule } from 'vhobjects-service';
import { WidthHeightConfigModule } from 'vhobjects-service';
import { RotateConfigModule } from 'vhobjects-service';
import { PaddingConfigModule } from 'vhobjects-service';
import { FilterConfigModule } from 'vhobjects-service';
import { BrightnessContrastConfigModule } from 'vhobjects-service';
import { TimeFormatConfigModule } from 'vhobjects-service'; 
import { TotalRowColProductsConfigModule } from 'vhobjects-service';
import { SlideConfigModule } from 'vhobjects-service';
import { IconLeftConfigModule } from 'vhobjects-service';
import { IconRightConfigModule } from 'vhobjects-service';
import { PositionInVirtualConfigModule } from 'vhobjects-service';
import { MarginConfigModule } from 'vhobjects-service';
import { PositionInConfigModule } from 'vhobjects-service';
import { ImageUploadConfigModule } from 'vhobjects-service';
import { ImageUploadOptionConfigModule } from 'vhobjects-service';

import { BackgroundImageConfigModule } from 'vhobjects-service';
import { BordersConfigModule } from 'vhobjects-service';
import { AnimationsConfigModule } from 'vhobjects-service';
import { ChooseAnimationsConfigModule } from 'vhobjects-service';
import { BordersRadiusConfigModule } from 'vhobjects-service';
import { LanguageService } from 'vhobjects-service/src/services';

import { AtwPageAdminConfig } from './page-admin-config/page-admin-config.component';
import { AtwTextCollapseAdminConfig } from './objects/basic/text-collapse/admin-config/text-collapse-admin-config/text-collapse-admin-config.component';
import { AtwTextParagraphAdminConfig } from './objects/basic/text-paragraph/admin-config/text-paragraph-admin-config/text-paragraph-admin-config.component';
import { AtwTextRepeatAdminConfig } from './objects/basic/text-repeat/admin-config/text-repeat-admin-config/text-repeat-admin-config.component';
import { AtwTextAdminConfig } from './objects/basic/text/admin-config/text-admin-config/text-admin-config.component';
import { AtwSearchAdminConfig } from './objects/basic/search/admin-config/search-admin-config/search-admin-config.component';
import { AtwVideoAdminConfig } from './objects/basic/video/admin-config/video-admin-config/video-admin-config.component';
import { AtwButtonAdminConfig } from './objects/basic/button/admin-config/button-admin-config/button-admin-config.component';
import { AtwDynamicFilterAdminConfig } from './objects/product/dynamic-filter/admin-config/dynamic-filter-admin-config/dynamic-filter-admin-config.component';
import { AtwIconAdminConfig } from './objects/basic/icon/admin-config/icon-admin-config/icon-admin-config.component';
import { AtwImageAdminConfig } from './objects/basic/image/admin-config/image-admin-config/image-admin-config.component';
import { AtwMenuHorizontalAdminConfig } from './objects/menu/menu-horizontal/admin-config/menu-horizontal-admin-config/menu-horizontal-admin-config.component';
import { AtwMenuVerticalAdminConfig } from './objects/menu/menu-vertical/admin-config/menu-vertical-admin-config/menu-vertical-admin-config.component';
import { AtwPopupAdminConfig } from './objects/basic/popup/admin-config/popup-admin-config/popup-admin-config.component';
import { AtwShapeAdminConfig } from './objects/basic/shape/admin-config/shape-admin-config/shape-admin-config.component';
import { AtwBreadcrumbAdminConfig } from './objects/basic/breadcrumb/admin-config/breadcrumb-admin-config/breadcrumb-admin-config.component';
import { AtwButtonShowModalAdminConfig } from './objects/basic/button-show-modal/admin-config/button-show-modal-admin-config/button-show-modal-admin-config.component';
import { AtwCustomizeObjectAdminConfig } from './objects/basic/customize-object/admin-config/customize-object-admin-config/customize-object-admin-config.component';
import { AtwHoverAdminConfig } from './objects/basic/hover/admin-config/hover-admin-config/hover-admin-config.component';
import { AtwImageBeforeAfterSliderAdminConfig } from './objects/basic/image-before-after-slider/admin-cofnig/image-before-after-slider-admin-config/image-before-after-slider-admin-config.component';
import { AtwLineAdminConfig } from './objects/basic/line/admin-config/line-admin-config/line-admin-config.component';
import { AtwMapAdminConfig } from './objects/basic/map/admin-config/map-admin-config/map-admin-config.component';
import { AtwMultiLanguageAdminConfig } from './objects/basic/multi-language/admin-config/multi-language-admin-config/multi-language-admin-config.component';
import { AtwNumberCountingAdminConfig } from './objects/basic/number-counting/admin-config/number-counting-admin-config/number-counting-admin-config.component';
import { AtwPdfViewerAdminConfig } from './objects/basic/pdf-viewer/admin-config/pdf-viewer-admin-config/pdf-viewer-admin-config.component';
import { AtwProfileUserAdminConfig } from './objects/profiles/admin-config/profile-user-admin-config/profile-user-admin-config.component';
import { AtwProfileWebsiteAdminConfig } from './objects/profile-website/admin-config/profile-website-admin-config/profile-website-admin-config.component';
import { AtwBillCodeAdminConfig } from './objects/bill/bill-code/admin-config/bill-code-admin-config/bill-code-admin-config.component';
import { AtwDateBillAdminConfig } from './objects/bill/date-bill/admin-config/date-bill-admin-config/date-bill-admin-config.component';
import { AtwTotalPriceBillAdminConfig } from './objects/bill/total-price-bill/admin-config/total-price-bill-admin-config/total-price-bill-admin-config.component';
import { AtwButtonQuantityCartAdminConfig } from './objects/cart/button-quantity-cart/admin-config/button-quantity-cart-admin-config/button-quantity-cart-admin-config.component';
import { AtwCheckBoxChooseProductAdminConfig } from './objects/cart/check-box-choose-product/admin-config/check-box-choose-product-admin-config/check-box-choose-product-admin-config.component';
import { AtwDateDeliveryAdminConfig } from './objects/cart/date-delivery/admin-config/date-delivery-admin-config/date-delivery-admin-config.component';
import { AtwExportBillAdminConfig } from './objects/cart/export-bill/admin-config/export-bill-admin-config/export-bill-admin-config.component';
import { AtwFeeAdminConfig } from './objects/cart/fee/admin-config/fee-admin-config/fee-admin-config.component';
import { AtwNoteBillAdminConfig } from './objects/cart/note-bill/admin-config/note-bill-admin-config/note-bill-admin-config.component';
import { AtwNoteProductAdminConfig } from './objects/cart/note-product/admin-config/note-product-admin-config/note-product-admin-config.component';
import { AtwPaymentCartAdminConfig } from './objects/cart/payment-cart/admin-config/payment-cart-admin-config/payment-cart-admin-config.component';
import { AtwImageCategoryAdminConfig } from './objects/category/image-category/admin-config/image-category-admin-config/image-category-admin-config.component';
import { AtwTextCategoryNameAdminConfig } from './objects/category/text-category-name/admin-config/text-category-name-admin-config/text-category-name-admin-config.component';
import { AtwAnimateButtonAdminConfig } from './objects/difference/animate-button/admin-config/animate-button-admin-config/animate-button-admin-config.component';
import { AtwMessengerAdminConfig } from './objects/difference/messenger/admin-config/messenger-admin-config/messenger-admin-config.component';
import { AtwZaloFollowAdminConfig } from './objects/difference/zalo-follow/admin-config/zalo-follow-admin-config/zalo-follow-admin-config.component';
import { AtwZaloShareAdminConfig } from './objects/difference/zalo-share/admin-config/zalo-share-admin-config/zalo-share-admin-config.component';
import { AtwBtnLoginLogout2StatesAdminConfig } from './objects/form/btn-login-logout-2states/admin-config/btn-login-logout-2states-admin-config/btn-login-logout-2states-admin-config.component';
import { AtwButtonLogoutAdminConfig } from './objects/form/button-logout/admin-config/button-logout-admin-config/button-logout-admin-config.component';
import { AtwInputAddressAdminConfig } from './objects/form/input-address/admin-config/input-address-admin-config/input-address-admin-config.component';
import { AtwInputConfirmPasswordAdminConfig } from './objects/form/input-confirm-password/admin-config/input-confirm-password-admin-config/input-confirm-password-admin-config.component';
import { AtwInputContentAdminConfig } from './objects/form/input-content/admin-config/input-content-admin-config/input-content-admin-config.component';
import { AtwInputEmailAdminConfig } from './objects/form/input-email/admin-config/input-email-admin-config/input-email-admin-config.component';
import { AtwInputNameAdminConfig } from './objects/form/input-name/admin-config/input-name-admin-config/input-name-admin-config.component';
import { AtwInputNewPasswordAdminConfig } from './objects/form/input-new-password/admin-config/input-new-password-admin-config/input-new-password-admin-config.component';
import { AtwInputPasswordAdminConfig } from './objects/form/input-password/admin-config/input-password-admin-config/input-password-admin-config.component';
import { AtwInputTelephoneAdminConfig } from './objects/form/input-telephone/admin-config/input-telephone-admin-config/input-telephone-admin-config.component';
import { AtwPopupOpenFormAdminConfig } from './objects/form/popup-open-form/admin-config/popup-open-form-admin-config/popup-open-form-admin-config.component';
import { AtwUserNameAdminConfig } from './objects/form/user-name/admin-config/user-name-admin-config/user-name-admin-config.component';
import { AtwButtonFavoriteAdminConfig } from './objects/product/button-favorite/admin-config/button-favorite-admin-config/button-favorite-admin-config.component';
import { AtwButtonQuantityAdminConfig } from './objects/product/button-quantity/admin-config/button-quantity-admin-config/button-quantity-admin-config.component';
import { AtwButtonViewDetailAdminConfig } from './objects/product/button-view-detail/admin-config/button-view-detail-admin-config/button-view-detail-admin-config.component';
import { AtwChooseSubproductAdminConfig } from './objects/product/choose-subproduct/admin-config/choose-subproduct-admin-config/choose-subproduct-admin-config.component';
// import { AtwCustomizeNewFieldAdminConfig } from './objects/product/customize-newField/admin-config/customize-newField-admin-config/customize-newField-admin-config.component';
import { AtwFavoriteAdminConfig } from './objects/product/favorite/admin-config/favorite-admin-config/favorite-admin-config.component';
import { AtwImageDetailAdminConfig } from './objects/product/image-detail/admin-config/image-detail-admin-config/image-detail-admin-config.component';
import { AtwImageProductAdminConfig } from './objects/product/image-product/admin-config/image-product-admin-config/image-product-admin-config.component';
import { AtwImageVideoDetailAdminConfig } from './objects/product/image-video-detail/admin-config/image-video-detail-admin-config/image-video-detail-admin-config.component';
import { AtwNewFieldCkeditorAdminConfig } from './objects/product/newField-ckeditor/admin-config/newField-ckeditor-admin-config/newField-ckeditor-admin-config.component';
import { AtwPopupDetailAdminConfig } from './objects/product/popup-detail/admin-config/popup-detail-admin-config/popup-detail-admin-config.component';
import { AtwPopupInteractiveAdminConfig } from './objects/product/popup-interactive/admin-config/popup-interactive-admin-config/popup-interactive-admin-config.component';
import { AtwRangePriceAdminConfig } from './objects/product/range-price/admin-config/range-price-admin-config/range-price-admin-config.component';
import { AtwSortProductAdminConfig } from './objects/product/sort-product/admin-config/sort-product-admin-config/sort-product-admin-config.component';
import { AtwTextBrandAdminConfig } from './objects/product/text-brand/admin-config/text-brand-admin-config/text-brand-admin-config.component';
import { AtwTextDiscountAdminConfig } from './objects/product/text-discount/admin-config/text-discount-admin-config/text-discount-admin-config.component';
import { AtwTextDiscountValueAdminConfig } from './objects/product/text-discount-value/admin-config/text-discount-value-admin-config/text-discount-value-admin-config.component';
import { AtwTextNameAdminConfig } from './objects/product/text-name/admin-config/text-name-admin-config/text-name-admin-config.component';
import { AtwTextPriceAdminConfig } from './objects/product/text-price/admin-config/text-price-admin-config/text-price-admin-config.component';
import { AtwTextPriceSaleAdminConfig } from './objects/product/text-price-sale/admin-config/text-price-sale-admin-config/text-price-sale-admin-config.component';
import { AtwTextShortDescriptionAdminConfig } from './objects/product/text-short-description/admin-config/text-short-description-admin-config/text-short-description-admin-config.component';
import { AtwUnitsAdminConfig } from './objects/product/units/admin-config/units-admin-config/units-admin-config.component';
import { AtwOrdinalRecruitmentAdminConfig } from './objects/recruitment/ordinal-recruitment/admin-config/ordinal-recruitment-admin-config/ordinal-recruitment-admin-config.component';
import { AtwUploadFileAdminConfig } from './objects/recruitment/upload-file/admin-config/upload-file-admin-config/upload-file-admin-config.component';
import { AtwButtonActiveAdminConfig } from './objects/sn-imei/button-active/admin-config/button-active-admin-config/button-active-admin-config.component';
import { AtwButtonSearchSnimeiAdminConfig } from './objects/sn-imei/button-search-snimei/admin-config/button-search-snimei-admin-config/button-search-snimei-admin-config.component';
import { AtwNewFieldSnimeiAdminConfig } from './objects/sn-imei/new-field-snimei/admin-config/new-field-snimei-admin-config/new-field-snimei-admin-config.component';
import { AtwRemainingTimeAdminConfig } from './objects/sn-imei/remaining-time/admin-config/remaining-time-admin-config/remaining-time-admin-config.component';
import { AtwSearchSnimeiAdminConfig } from './objects/sn-imei/search-snimei/admin-config/search-snimei-admin-config/search-snimei-admin-config.component';
import { AtwButtonPreviewAdminConfig } from './objects/website/button-preview/admin-config/button-preview-admin-config/button-preview-admin-config.component';
import { AtwButtonPreviewImageAdminConfig } from './objects/website/button-preview-image/admin-config/button-preview-image-admin-config/button-preview-image-admin-config.component';
import { AtwDateUpdateAdminConfig } from './objects/website/date-update/admin-config/date-update-admin-config/date-update-admin-config.component';
import { AtwQuantitySoldAdminConfig } from './objects/website/quantity_sold/admin-config/quantity-sold-admin-config/quantity-sold-admin-config.component';
import { AtwWebsiteVersionAdminConfig } from './objects/website/version/admin-config/website-version-admin-config/website-version-admin-config.component';
import { AtwImageVideoDetailImageAdminConfig } from './objects/product/image-video-detail/admin-config/image-video-detail-image-admin-config/image-video-detail-image-admin-config.component';
import { AtwImageDetailAdminConfigImage } from './objects/product/image-detail/admin-config/image-detail-admin-config-image/image-detail-admin-config-image.component';
import { AtwButtonRepeatAdminConfig } from './objects/basic/button-repeat/admin-config/button-repeat-admin-config/button-repeat-admin-config.component';
import { AtwImageRepeatAdminConfig } from './objects/basic/image-repeat/admin-config/image-repeat-admin-config/image-repeat-admin-config.component';
import { AtwActiveDateAdminConfig } from './objects/sn-imei/active-date/admin-config/active-date-admin-config/active-date-admin-config.component';
import { AtwTextActiveAdminConfig } from './objects/sn-imei/text-active/admin-config/text-active-admin-config/text-active-admin-config.component';
import { AtwFrameBlankAdminConfig } from './frames/frame-blank/admin-config/frame-blank-admin-config/frame-blank-admin-config.component';
import { AtwFrameCartProductsAdminConfig } from './frames/frame-cart-products/admin-config/frame-cart-products-admin-config/frame-cart-products-admin-config.component';
import { AtwFrameCategoryDetailAdminConfig } from './frames/frame-category-detail/admin-config/frame-category-detail-admin-config/frame-category-detail-admin-config.component';
import { AtwFrameCollapseAdminConfig } from './frames/frame-collapse/admin-config/frame-collapse-admin-config/frame-collapse-admin-config.component';
import { AtwFrameBannerAdminConfig } from './frames/frame-banner/admin-config/frame-banner-admin-config/frame-banner-admin-config.component';
import { AtwFrameProductsAdminConfig } from './frames/frame-products/admin-config/frame-products-admin-config/frame-products-admin-config.component';
import { AtwFrameProductDetailAdminConfig } from './frames/frame-product-detail/admin-config/frame-product-detail-admin-config/frame-product-detail-admin-config.component';
import { AtwFrameProductByCategoryAdminConfig } from './frames/frame-product-by-category/admin-config/frame-product-by-category-admin-config/frame-product-by-category-admin-config.component';
import { AtwFrameProductByCategoryViewMoreAdminConfig } from './frames/frame-product-by-category-view-more/admin-config/frame-product-by-category-view-more-admin-config/frame-product-by-category-view-more-admin-config.component';
import { AtwFrameProductsViewedAdminConfig } from './frames/frame-products-viewed/admin-config/frame-products-viewed-admin-config/frame-products-viewed-admin-config.component';
import { AtwFrameResultAdminConfig } from './frames/frame-result/admin-config/frame-result-admin-config/frame-result-admin-config.component';
import { AtwFrameSearchByKeywordAdminConfig } from './frames/frame-search-by-keyword/admin-config/frame-search-by-keyword-admin-config/frame-search-by-keyword-admin-config.component';
import { AtwFrameSnimeiDetailAdminConfig } from './frames/frame-snimei-detail/admin-config/frame-snimei-detail-admin-config/frame-snimei-detail-admin-config.component';
import { AtwFrameCategoriesAdminConfig } from './frames/frame-categories/admin-config/frame-categories-admin-config/frame-categories-admin-config.component';
import { AtwFrameTabsAdminConfig } from './frames/frame-tabs/admin-config/frame-tabs-admin-config/frame-tabs-admin-config.component';
import { AtwBlockBlankAdminConfig } from './blocks/block-blank/admin-config/block-blank-admin-config/block-blank-admin-config.component';
import { AtwBlockFooterAdminConfig } from './blocks/block-footer/admin-config/block-footer-admin-config/block-footer-admin-config.component';
import { AtwBlockHeaderAdminConfig } from './blocks/block-header/admin-config/block-header-admin-config/block-header-admin-config.component';
import { AtwBlockChatboxAdminConfig } from './blocks/block-chatboxs/admin-config/block-chatbox-admin-config/block-chatbox-admin-config.component';
import { AtwTableOfContentAdminConfig } from './objects/news/table-of-content/admin-config/table-of-content-admin-config/table-of-content-admin-config.component';
import { AtwDatePostedNewsAdminConfig } from './objects/news/date-posted-news/admin-config/date-posted-news-admin-config/date-posted-news-admin-config.component';
import { AtwTextNewsTitleAdminConfig } from './objects/news/text-news-title/admin-config/text-news-title-admin-config/text-news-title-admin-config.component';
import { AtwViewersNewsAdminConfig } from './objects/news/viewers-news/admin-config/viewers-news-admin-config/viewers-news-admin-config.component';
import { AtwDisplayPropertyAdminConfig } from './objects/foods/display-property/admin-config/display-property-admin-config/display-property-admin-config.component';
import { AtwChoosePropertyAdminConfig } from './objects/foods/choose-property/admin-config/choose-property-admin-config/choose-property-admin-config.component';
import { AtwButtonShowModalDetailAdminConfig } from './objects/product/button-show-modal-detail/admin-config/button-show-modal-detail-admin-config/button-show-modal-detail-admin-config.component';
import { CustomizeNewFieldAdminConfigModule } from './objects/product/customize-newField/admin-config/customize-newField-admin-config/customize-newField-admin-config.module';
import { AtwFlipBookAdminConfig } from './objects/basic/flip-book/admin-config/flip-book-admin-config.component';
import { AtwSearchCustomizeAdminConfig } from './frames/search-customize/admin-config/search-customize-admin-config/search-customize-admin-config.component';
import { AtwFrameCommentAdminConfig } from './frames/frame-comment/admin-config/frame-comment-admin-config/frame-comment-admin-config.component';
import { AtwFrameRepliedAdminConfig } from './frames/frame-replied/admin-config/frame-replied-admin-config/frame-replied-admin-config.component';
import { AtwFrameReplyCommentAdminConfig } from './frames/frame-reply-comment/admin-config/frame-reply-comment-admin-config/frame-reply-comment-admin-config.component';
import { AtwInputCalculateCustomAdminConfig } from './objects/form/input-calculate-custom/admin-config/input-calculate-custom-admin-config.component';
import { AtwSelectAdmin } from './objects/form/select/admin/select-admin/select-admin.component';
import { AtwSharingSocialAdminConfig } from './objects/news/sharing-social/admin-config/sharing-social-admin-config.component';
import { AtwCategoryProductAdminConfig } from './objects/product/category-product/admin-config/category-product-admin-config.component';
import { AtwDateCreateProductAdminConfig } from './objects/product/date-create-product/admin-config/date-create-product-admin-config.component';

import { AtwBlockBlankAdmin } from './blocks/block-blank/admin/block-blank-admin/block-blank-admin.component';
import { AtwMapRepeatAdminConfig } from './objects/basic/map-repeat/admin-config/map-repeat-admin-config.component';
import { AtwTextAvailabilityAdminConfig } from './objects/product/text-availability/admin-config/text-availability-admin-config.component'
import { AtwVideoRepeatAdminConfig } from './objects/basic/video-repeat/admin-config/video-repeat-admin-config.component';
import { SelectLanguageConfigModule } from './select-language-config/select-language-config.module';
import { AtwRadioPaymentMethodAdminConfig } from './objects/cart/radio-payment-method/admin-config/radio-payment-method-admin-config/radio-payment-method-admin-config.component';
import { AtwDateRepeatAdminConfig } from './objects/basic/date-repeat/admin-config/date-repeat-admin-config.component';
import { AtwPopupRepeatAdminConfig } from './objects/basic/popup-repeat/admin-config/popup-repeat-admin-config/popup-repeat-admin-config.component';
import { ColorContrastComponent } from './color-contrast/color-contrast.component';
import { AtwReviewAdminConfig } from './objects/review/admin-config/review-admin-config/review-admin-config.component';
import { AtwImageDetailRepeatAdminConfig } from './objects/basic/image-detail-repeat/admin-config/image-detail-repeat-admin-config/image-detail-repeat-admin-config.component';
import { AtwListOrderAdminConfig } from './objects/cart/list-order/admin-config/list-order-admin-config/list-order-admin-config.component';
import { AtwTabBarAdminConfig } from './objects/basic/tab-bar/admin-config/tab-bar-admin-config.component';
import { AtwContentPreviewSliderAdminConfig } from './objects/basic/content-preview-slider/admin-config/content-preview-slider-admin-config/content-preview-slider-admin-config.component';
import { AtwTextConnectorRowRepeatAdminConfig } from './objects/basic/text-connector-row-repeat/admin-config/text-connector-row-repeat-admin-config/text-connector-row-repeat-admin-config.component';
const componentAminConfig = [
  AtwVideoRepeatAdminConfig,
  AtwPageAdminConfig,

  AtwFlipBookAdminConfig,
  AtwDisplayPropertyAdminConfig,
  AtwDisplayPropertyAdminConfig,
  AtwChoosePropertyAdminConfig,
  AtwButtonShowModalDetailAdminConfig,
  AtwBlockBlankAdminConfig,
  AtwBlockBlankAdmin,
  AtwBlockChatboxAdminConfig,
  AtwBlockFooterAdminConfig,
  AtwBlockHeaderAdminConfig,

  AtwFrameProductsAdminConfig,
  AtwFrameProductDetailAdminConfig,
  AtwFrameProductByCategoryAdminConfig,
  AtwFrameProductByCategoryViewMoreAdminConfig,
  AtwFrameProductsViewedAdminConfig,
  AtwFrameBlankAdminConfig,
  AtwFrameCartProductsAdminConfig,
  AtwFrameCommentAdminConfig,
  AtwFrameSnimeiDetailAdminConfig,
  AtwFrameCategoryDetailAdminConfig,
  AtwFrameRepliedAdminConfig,
  AtwFrameReplyCommentAdminConfig,
  AtwFrameSearchByKeywordAdminConfig,
  AtwSearchCustomizeAdminConfig,
  AtwTextCategoryNameAdminConfig,
  AtwFrameResultAdminConfig,
  AtwFrameTabsAdminConfig,
  AtwFrameCollapseAdminConfig,
  AtwFrameBannerAdminConfig,
  AtwFrameCategoriesAdminConfig,
  AtwTableOfContentAdminConfig,
  AtwTextActiveAdminConfig,
  AtwActiveDateAdminConfig,
  AtwImageRepeatAdminConfig,
  AtwButtonRepeatAdminConfig,
  AtwImageDetailAdminConfigImage,
  AtwImageVideoDetailImageAdminConfig,
  AtwTextCollapseAdminConfig,
  AtwTextParagraphAdminConfig,
  AtwTextRepeatAdminConfig,
  AtwTextAdminConfig,
  AtwSearchAdminConfig,
  AtwVideoAdminConfig,
  AtwButtonAdminConfig,
  AtwDynamicFilterAdminConfig,
  AtwIconAdminConfig,
  AtwImageAdminConfig,
  AtwMenuHorizontalAdminConfig,
  AtwMenuVerticalAdminConfig,
  AtwPopupAdminConfig,
  AtwShapeAdminConfig,
  AtwBreadcrumbAdminConfig,
  AtwButtonShowModalAdminConfig,
  AtwCustomizeObjectAdminConfig,
  AtwHoverAdminConfig,
  AtwImageBeforeAfterSliderAdminConfig,
  AtwLineAdminConfig,
  AtwMapAdminConfig,
  AtwMapRepeatAdminConfig,
  AtwMultiLanguageAdminConfig,
  AtwNumberCountingAdminConfig,
  AtwPdfViewerAdminConfig,
  AtwProfileUserAdminConfig,
  AtwProfileWebsiteAdminConfig,
  AtwBillCodeAdminConfig,
  AtwDateBillAdminConfig,
  AtwTotalPriceBillAdminConfig,
  AtwButtonQuantityCartAdminConfig,
  AtwCheckBoxChooseProductAdminConfig,
  AtwDateDeliveryAdminConfig,
  AtwExportBillAdminConfig,
  AtwFeeAdminConfig,
  AtwNoteBillAdminConfig,
  AtwNoteProductAdminConfig,
  AtwPaymentCartAdminConfig,
  AtwImageCategoryAdminConfig,
  AtwAnimateButtonAdminConfig,
  AtwMessengerAdminConfig,
  AtwZaloFollowAdminConfig,
  AtwZaloShareAdminConfig,
  AtwDatePostedNewsAdminConfig,
  AtwTextNewsTitleAdminConfig,
  AtwViewersNewsAdminConfig,
  AtwBtnLoginLogout2StatesAdminConfig,
  AtwButtonLogoutAdminConfig,
  AtwInputAddressAdminConfig,
  AtwInputConfirmPasswordAdminConfig,
  AtwInputContentAdminConfig,
  AtwInputEmailAdminConfig,
  AtwInputNameAdminConfig,
  AtwInputNewPasswordAdminConfig,
  AtwInputPasswordAdminConfig,
  AtwInputTelephoneAdminConfig,
  AtwPopupOpenFormAdminConfig,
  AtwUserNameAdminConfig,
  AtwButtonFavoriteAdminConfig,
  AtwButtonQuantityAdminConfig,
  AtwButtonViewDetailAdminConfig,
  AtwChooseSubproductAdminConfig,
  // AtwCustomizeNewFieldAdminConfig,
  AtwFavoriteAdminConfig,
  AtwImageDetailAdminConfig,
  AtwImageProductAdminConfig,
  AtwImageVideoDetailAdminConfig,
  AtwNewFieldCkeditorAdminConfig,
  AtwPopupDetailAdminConfig,
  AtwPopupInteractiveAdminConfig,
  AtwRangePriceAdminConfig,
  AtwSortProductAdminConfig,
  AtwTextBrandAdminConfig,
  AtwTextDiscountAdminConfig,
  AtwTextDiscountValueAdminConfig,
  AtwTextNameAdminConfig,
  AtwTextPriceAdminConfig,
  AtwTextPriceSaleAdminConfig,
  AtwTextShortDescriptionAdminConfig,
  AtwUnitsAdminConfig,
  AtwOrdinalRecruitmentAdminConfig,
  AtwUploadFileAdminConfig,
  AtwButtonActiveAdminConfig,
  AtwButtonSearchSnimeiAdminConfig,
  AtwNewFieldSnimeiAdminConfig,
  AtwRemainingTimeAdminConfig,
  AtwSearchSnimeiAdminConfig,
  AtwButtonPreviewAdminConfig,
  AtwButtonPreviewImageAdminConfig,
  AtwDateUpdateAdminConfig,
  AtwQuantitySoldAdminConfig,
  AtwWebsiteVersionAdminConfig,
  AtwInputCalculateCustomAdminConfig,
  AtwSelectAdmin,
  AtwSharingSocialAdminConfig,
  AtwCategoryProductAdminConfig,
  AtwDateCreateProductAdminConfig,
  AtwTextAvailabilityAdminConfig,
  AtwRadioPaymentMethodAdminConfig,
  AtwDateRepeatAdminConfig,
  AtwPopupRepeatAdminConfig,
  AtwReviewAdminConfig,
  AtwImageDetailRepeatAdminConfig,
  AtwListOrderAdminConfig,
  AtwTabBarAdminConfig,
  AtwContentPreviewSliderAdminConfig,
  AtwTextConnectorRowRepeatAdminConfig 
];

@NgModule({
  declarations: [componentAminConfig,ColorContrastComponent],
  entryComponents: [componentAminConfig],
  imports: [
    CommonModule,
    NgZorroAntModule,
    BackgroundImageConfigModule,
    BordersConfigModule,
    AnimationsConfigModule,
    ChooseAnimationsConfigModule,
    BordersRadiusConfigModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    VhStringPercentPipeModule,
    TranslateModule,
    DynamicModule,
    CustomizeNewFieldAdminConfigModule,
    TextFormatConfigModule,
    HideShowConfigModule,
    LetterSpacingConfigModule,
    VhLanguagePipeModule,
    LineHeightConfigModule,
    ColorPickerModule,
    TextStyleConfigModule,
    LinkPageModule,
    ShadowConfigModule,
    SymbolConfigModule,
    ObjectFitConfigModule,
    DataAdminManagementConfigModule,
    PositionOutConfigModule,
    WidthHeightConfigModule,
    RotateConfigModule,
    PaddingConfigModule,
    FilterConfigModule,
    BrightnessContrastConfigModule,
    TotalRowColProductsConfigModule,
    TimeFormatConfigModule,
    SelectLanguageConfigModule,
    SlideConfigModule,
    IconLeftConfigModule,
    IconRightConfigModule,
    PositionInVirtualConfigModule,
    MarginConfigModule,
    PositionInConfigModule,
    ImageUploadConfigModule,
    ImageUploadOptionConfigModule,
  ],
  exports: [componentAminConfig],
  providers: [
    LanguageService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
  ],
})
export class AdminConfigModule {}
